var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 695,
    viewBox: "0 0 620 695",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 695,
    rx: 32,
    fill: "#FCD4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 620,
    height: 695
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 695,
    rx: 32,
    fill: "#D4E0FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_672)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.5,
    cy: 596.5,
    rx: 338.5,
    ry: 338.5,
    transform: "rotate(180 307.5 596.5)",
    fill: "#FBC1FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBackground);
export default __webpack_public_path__ + "static/media/purple-background.dedf0dad5699f26405d9e420909ebfd0.svg";
export { ForwardRef as ReactComponent };